import { tx } from "@/i18n/tx";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Responsive bottom-sheet (mobile) / centered dialog (tablet & desktop) with scrollable body and sticky footer.
export default function Sheet({ title, onClose, footer, children, wide = false, testId }) {
  return createPortal(
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-end sm:items-center justify-center sm:p-6" onClick={onClose} data-testid={testId}>
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-surface w-full ${wide ? "sm:max-w-2xl" : "sm:max-w-lg"} rounded-t-3xl sm:rounded-3xl flex flex-col max-h-[92dvh] sm:max-h-[88vh] shadow-2xl page-enter`}
      >
        <div className="flex items-center justify-between gap-3 px-5 sm:px-6 pt-5 pb-3 border-b border-c shrink-0">
          <h3 className="font-display text-xl sm:text-2xl truncate">{title}</h3>
          <button type="button" onClick={onClose} data-testid={testId ? `${testId}-close` : undefined} aria-label={tx("ui_sheet.k7d2062")} className="w-10 h-10 -mr-2 rounded-full flex items-center justify-center text-text-secondary hover:bg-surface-muted">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto overscroll-contain px-5 sm:px-6 py-4 space-y-4">{children}</div>
        {footer && (
          <div className="shrink-0 px-5 sm:px-6 pt-3 border-t border-c bg-surface sm:rounded-b-3xl" style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 14px)" }}>
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
